module.exports = __webpack_public_path__ + "static/media/S2N3-4.f72765c9.svg";